import AFRAME from 'aframe'
let THREE = require('three')

// TEXTURE CACHE
const textureLoader = new THREE.TextureLoader()
textureLoader.setCrossOrigin('')
// console.log(222, textureLoader)

let textureCache = {}

AFRAME.registerSystem('texture-cache', {
  schema: {},
  init: function() {
    this.cache = textureCache
  },
  tick: function() {},
  play: function() {},
  pause: function() {},
  getTexture(img, onLoad) {
    if (!textureCache[img.src]) {
      textureCache[img.src] = textureLoader.load(img.src, onLoad)
    } else {
      if (onLoad) onLoad()
    }
    return textureCache[img.src]
  },
  destroyCache() {
    for (let key in textureCache) {
      let texture = textureCache[key]
      texture.dispose()
    }
  },
})
